import React from 'react';
import { EveFooter } from '@ver-uds/e-verify';

const PageFooter = (): JSX.Element => {
  return (
    <div>
      <EveFooter />
    </div>
  );
};

export default PageFooter;
